import { ObjectId } from "bson";
import { Colors } from "./LotteryV2Configuration";

export enum POSADeliveryStatus {
  Pending = "pending",
  Designed = "designed",
  ToPrint = "to_print",
  Printing = "printing",
  Printed = "printed",
  ToShip = "to_ship",
  Shipped = "shipped",
  Delivered = "delivered",
  DeliveredAtNeighbours = "delivered_at_neighbours",
  DeliveredAtPickupPoint = "delivered_at_pickup_point",
  Canceled = "canceled",
  DeliveryFailed = "delivery_failed",
  CarrierUpdateAvailable = "carrier_update_available",
  ArtworkIssue = "artwork_issue",
  NeedsRedesign = "needs_redesign",
}

export default interface POSADelivery extends POSADeliveryBase {
  _id: ObjectId;
}

export interface POSADeliveryJavascriptDTO extends POSADeliveryBase {
  _id: string;
}

export interface POSADeliveryJavaDTO extends POSADeliveryBase {
  id: string;
}

export interface POSADeliveryBase {
  ts: number;

  businessUserId: string;
  parentBusinessUserId: string;
  placeName: string;

  plvTypeId: string;
  billId: string;

  desiredQty: number;
  shippedQty: number;

  deadlineTs: number;

  designedTs: number;
  toPrintTs: number;
  printingTs: number;
  printedTs: number;
  toShipTs: number;
  shippingTs: number;
  deliveryTs: number;
  canceledTs: number;

  status: POSADeliveryStatus;

  hasCustomColors: boolean;
  colors?: Colors;
  hasLogo: boolean;
  hasPlaceName: boolean;
  hasGiftName: boolean;

  comments: string;

  googleDriveFileId: string;

  colissimoId: string | undefined;
  colissimoPrice: number;

  helloPrintRequestId: string | undefined;
  helloPrintId: string | undefined;
  helloPrintPrice: number;
  helloPrintShippingPrice: number;

  // client-side fields
  isSelected: boolean;

  customerComments: string;
}
